import { toast } from 'sonner'
import { reviewChangeRefused } from './reviewLockText'

/**
 * Страховка хендлера записи на время проверки курса: кнопка гаснет по тому же
 * признаку, но её могли нажать за миг до того, как опрос принёс `pending`
 * (или хендлер зовут не из кнопки — dnd, диалог подтверждения). `true` —
 * отказано, автор уже увидел причину, запрос слать нельзя.
 */
export const refusedByReview = (isFrozen: boolean): boolean => {
  if (!isFrozen) return false
  toast.error(reviewChangeRefused())
  return true
}
